module.exports = __webpack_public_path__ + "static/img/cardodge.0110aa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardodge.png
// module id = Hr6k
// module chunks = 0